﻿import { initRegisterForm } from "./register";
import {
  hasMinLength,
  hasLowercase,
  hasUppercase,
  hasDigit,
} from "../../utils";

const EMAIL_SUGGESTION = [
  "@gmail.com",
  "@hotmail.com",
  "@hotmail.es",
  "@icloud.com",
  "@yahoo.es",
  "@outlook.com",
  "@nomail.com",
  "@yahoo.com",
  "@outlook.es",
  "@live.com",
];

$(() => {
  const step1Form = $("#registerStep1Form");

  const pwMinLength = $("#pwMinLength");
  const pwLowercase = $("#pwLowercase");
  const pwUppercase = $("#pwUppercase");
  const pwDigit = $("#pwDigit");

  $("#userPassword").on("input", (event) => {
    const password = event.target.value;

    addPasswordValidationClass(hasMinLength(8, password), pwMinLength);
    addPasswordValidationClass(hasLowercase(password), pwLowercase);
    addPasswordValidationClass(hasUppercase(password), pwUppercase);
    addPasswordValidationClass(hasDigit(password), pwDigit);
  });

  initRegisterForm(step1Form);

  _initEmailSuggestion();
});

function addPasswordValidationClass(isValid, element) {
  if (isValid) {
    $(element).removeClass("aw-password-format__validation--invalid");
    $(element).addClass("aw-password-format__validation--valid");
  } else {
    $(element).removeClass("aw-password-format__validation--valid");
    $(element).addClass("aw-password-format__validation--invalid");
  }
}

function _initEmailSuggestion() {
  $('[data-testid="input_email_input"]').on("focus", (event) => {
    _handleSuggestions(event);
  });
  $('[data-testid="input_email_input"]').on("input", (event) => {
    _handleSuggestions(event);
  });

  $('[data-testid="input_email_input"]').on("focusout", (event) => {
    setTimeout(() => $("#email_suggestions").addClass("eui-d-none"), 300);
  });
}

function _handleSuggestions(event) {
  const newValue = event.target.value;
  const hasAtChar = newValue.indexOf("@") !== -1;

  if (!hasAtChar) {
    // Hide suggestion
    return;
  }

  const email = newValue.split("@")[0];
  const domain = "@" + newValue.split("@")[1];
  const newSuggestions = EMAIL_SUGGESTION.filter(
    (suggestion) => suggestion.indexOf(domain) !== -1 && suggestion !== domain
  );

  // Show filtered suggestions
  $("#email_suggestions").removeClass("eui-d-none");
  $("#email_suggestions").empty();
  newSuggestions.forEach((suggestion) => {
    $("#email_suggestions").append(
      `<li class="eui-d-flex eui-d-flex--vertical-center eui-cursor-pointer eui-bg-color-grey-0 eui-dropdown__option" data-suggestion-value="${suggestion}">${suggestion}</li>`
    );
  });
  document.querySelectorAll("#email_suggestions li").forEach((element) => {
    $(element).on("click", () => {
      const newDomain = element.attributes["data-suggestion-value"].value;
      $('[data-testid="input_email_input"]')
        .val(`${email}${newDomain}`)
        .trigger("input");
      $('[data-testid="input_email_input"]').focus();
      $('[data-testid="input_email_input"]').blur();
      $('[data-testid="input_email_input"]').trigger("focusout");
      $("#email_suggestions").addClass("eui-d-none");
    });
  });
}
